interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
  id?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = 'left',
  id,
}: SectionHeadingProps) {
  const isCenter = align === 'center';
  return (
    <div
      className={`reveal max-w-3xl ${isCenter ? 'mx-auto text-center' : ''}`}
    >
      <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium tracking-wide text-accent-900">
        <span className="h-1.5 w-1.5 rounded-full bg-accent-500"></span>
        {eyebrow}
      </span>
      <h2
        id={id}
        className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl"
      >
        {title}
      </h2>
      {desc ? (
        <p className="mt-4 text-sm leading-7 text-foreground-600 md:text-base md:leading-8">
          {desc}
        </p>
      ) : null}
    </div>
  );
}